// robot_status payload sections holding device data, shaped as { group: [instance] }.
export const DEVICE_SECTION = Object.freeze({
  DEVICES: 'devices',
  MOBILE_BASE: 'mobile_base',
});

// Boolean field marking a device instance as disabled; excluded from failure checks.
export const IS_ENABLED_KEY = 'is_enabled';
